import React from 'react';
import { useTooltip } from '../../hooks/useTooltip';

const ButtonNav = ({ 
  icon, 
  value, 
  isCurrent, 
  iconOnly, 
  notification, 
  tooltipLabel, 
  isToday = false,
  loading = false 
}) => {
  const selectedClasses = isCurrent
    ? "shadow-[inset_0_0_0_2px_rgba(255,255,255,1)] text-amber-50"
    : "hover:shadow-[inset_0_0_0_2px_rgba(255,255,255,.2)] text-amber-50/50 hover:text-amber-50 cursor-pointer";
    
  const notificationClasses = notification
    ? "flex order-first items-center h-2 w-2 group-hover:-mr-[4px] group-hover:h-[18px] group-hover:w-auto group-hover:px-[2px] overflow-hidden group-hover:overflow-hidden indent-2 text-base group-hover:indent-0 rounded-full bg-amber-50 text-amber-50 group-hover:bg-transparent transition-[margin] duration-300 ease-[cubic-bezier(0.175, 0.885, 0.32, 1.275)]"
    : "";
    
  const iconOnlyClasses = iconOnly ? "!w-10 !gap-0" : "";
  const tooltipProps = useTooltip(tooltipLabel, 'bottom', { x: 0, y: 8 });

  const todayContent = loading ? (
    <span className="material-symbols-outlined">all_inclusive</span>
  ) : icon;

  const baseClasses = `group flex sm:flex-row flex-col sm:gap-1 items-center justify-center sm:w-fit w-full sm:h-10 h-16 sm:pl-3 sm:pr-[14px] sm:px-4 uppercase pangram-sans-bold max-sm:text-sm tracking-wider rounded-3xl cursor-pointer select-none ${selectedClasses} ${iconOnlyClasses}`;

  if (isToday) {
    return (
      <div className={`flex max-sm:pt-[6px] gap-[2px] ${baseClasses}`}>
        <span className={`flex px-[6px] h-5 items-center text-neutral-950 rounded-full ${
          isCurrent
            ? "bg-amber-50"
            : "bg-amber-50/50 group-hover:bg-amber-50"
        }`}>
          {todayContent}
        </span>
        <span className="ml-1">{value}</span>
      </div>
    );
  }

  return (
    <div className={baseClasses} {...tooltipProps}>
      <span className="text-xl material-symbols-outlined">{icon}</span>
      <span className={notificationClasses}>{value}</span>
    </div>
  );
};

export default ButtonNav;